<template>
  <div id="bg-layer" :class="{'is-active': isActive}" @click="navClose">
  </div>
</template>

<script>
  export default {
    computed: {
      isActive() {
        return this.$store.getters.isBgLayerActive;
      }
    },
    methods: {
      navClose() {
        this.$store.dispatch("navToggle", false);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/BgLayer.vue